<template>
  <w-flex justify-center align-center >
    <div class="w-card__content content-hardcode">
      <w-flex class="mt3">
        <div class="xs11 text-right" >
          <w-button dark class="green--bg ml1" @click="tambah" >
              <w-icon class="mr1">fal fa-plus</w-icon> Tambah
          </w-button>
        </div>
      </w-flex>
    </div>
  </w-flex>
  <div class="w-table-wrap" >
    <table class="w-table" color="light" >
      <thead>
        <tr>
          <th class="w-table__header  text-left" width="1%">No</th>
          <th class="w-table__header  text-left">Kod</th>
          <th class="w-table__header  text-left">Status</th>
          <th class="w-table__header  text-left">AI Man</th>
          <th class="w-table__header  text-left"  width="1%">Tindakan</th>
        </tr>
      </thead>

      <tbody>
        <template v-if="list_sel.length == 0">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
          </tr>
        </template>
        <template v-for="(dt, ind) in list_sel">

          <template v-if="dt.pilih == true">
            <tr class="w-table__row" >
              <td class="w-table__cell text-left" >{{ind+1}}</td>
              <td class="w-table__cell text-left" >{{dt.kode}}</td>
              <td class="w-table__cell text-left" >{{dt.status}}</td>
              <td class="w-table__cell text-left" >{{dt.user}}</td>
              <td class="w-table__cell text-center"> 
                <w-button class="fs-2" bg-color="error-dark1" dark tile @click="padam(dt)">
                  <w-icon xs class="mr2">fal fa-trash</w-icon> Padam
                </w-button>
              </td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>
  </div>
  <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent"  :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-list</w-icon>
       Sel Telur
    </template>
      <div class="w-table-wrap" style="max-height: 400px;">
        <table class="w-table" color="light" >
          <thead>
            <tr>
              <th class="w-table__header  text-left" width="1%">No</th>
              <th class="w-table__header  text-left">Kod</th>
              <th class="w-table__header  text-left">Status</th>
              <th class="w-table__header  text-left">AI Man</th>
              <th class="w-table__header  text-left">Pilih</th>
            </tr>
          </thead>

          <tbody>
            <template v-for="(dt, ind) in sel_telur">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" >{{ind+1}}</td>
                <td class="w-table__cell text-left" >{{dt.kode}}</td>
                <td class="w-table__cell text-left" >{{dt.status}}</td>
                <td class="w-table__cell text-left" >{{dt.user}}</td>
                <td class="w-table__cell text-center">
                  <template v-if="dt.pilih==true">
                  <w-checkbox class="mr2" v-model="dt.pilih" @change="cekbaki(dt)"></w-checkbox>
                </template>
                <template v-if="dt.pilih==false">
                  <template v-if="disable==true">
                  <w-tooltip top align-left>
                    <template #activator="{ on }">
                      <w-checkbox v-on="on" class="mr2" v-model="dt.pilih" :disabled="disable" @change="cekbaki(dt)"></w-checkbox>
                      </template>
                      <template v-if="disable==true">
                      Tangki Tidak Mencukupi..
                      </template>
                  </w-tooltip>
                  </template>
                  <template v-else>
                    <w-checkbox class="mr2" v-model="dt.pilih" @change="cekbaki(dt)"></w-checkbox>
                  </template>
                </template>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="tutupmodal()">Tutup</w-button>
      <w-button class="my1" type="submit" @click="submit()">
          <w-icon dark tile class="mr2">fal fa-save</w-icon> Simpan
      </w-button>
    </template>
  </w-dialog>


</template>

<script>
export default {
  name: "Semen",
  props:{
    data: [Array, Object],
  },
  data() {
    return {
      form : {},
      datas : [],
      sel_telur: [],
      list_sel: [],
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
      },
      pilih_semua: false,
      kuantiti_total: 0,
      disable:false,
      baki: 0,
      
    }
  },
  methods:{
    tambah(){
      
      if(this.data.baki == 0){
           this.disable=true
      }
      this.baki = this.data.baki;
      this.getseltelur()
      this.dialog.show = true;
    },
    tutupmodal(){
      this.disable = false;
      this.dialog.show = false;
      this.data.baki =this.baki;
    },
    getseltelur(){
      this.$zcomm.get(this.api_service + 'tangki/sel_telur/'+this.data.id, {}).then(res => {
        this.sel_telur = res
      })
    },
    getListSeltelur(){
      this.$zcomm.get(this.api_service + 'tangki/list_seltelur/'+this.data.id, {}).then(res => {
        this.list_sel = res
      })
    },
    // pilihSemua(){
    //   // if (this.pilih_semua == true) {
    //     this.kuantiti_total = 0;
    //     for (var b in this.semen) {
    //         if (this.semen[b].pilih == true) {
    //             this. = this.semen.langht;
    //         }
    //         if (this.data.baki < this.data.kapasiti) {//tidak boleh melebihi kapasiti
    //           if (this.pilih_semua == true) {
    //             this.semen[b].pilih = true;
    //           }else{
    //             this.semen[b].pilih = false;
    //           }
    //         } else {
    //             this.$zutil.notifSweet("Melibihi Kuantiti", "error");
    //         }
    //     }
    //   // }
    // },
    cekbaki(dt) {
      // this.baki = this.data.baki;
      if(this.data.baki != 0){
        if(dt.pilih == false){
          this.data.baki = this.data.baki + 1;
          this.disable = false;
        }else{
          // this.disable=true
          this.data.baki = this.data.baki - 1;
        }
      }
      if(this.baki > 0){
         if(dt.pilih == false){
          this.data.baki = this.data.baki + 1;
          this.disable = false;
        }
      }
      if(this.data.baki == 0){
        this.disable=true
      }
    },
    submit(){
        this.form.tangki_id = this.data.id;
        this.form.seltelur = this.sel_telur;
        this.$zcomm.add( 'tangki.seltelur', this.form)
        .then(res => {
          this.getListSeltelur();
          this.dialog.show = false;
        })
        .finally(() => {
            this.dialog.loading = false;

        });
    }, 
    padam(dt){
      if (confirm('Adakah anda pasti untuk memadam rekod ini?')) {
            this.$zcomm.delete('tangki.seltelur_deleted', dt.id)
                .then(res => {
                  //update displayed record
                  this.sending = false;
                  this.getListSeltelur();
                  this.$inertia.visit(this.$page.url)
                  this.removeitem(res) // remove the data from list. no need to refresh page
                  if (typeof this.onAfterDelete === "function") {
                    this.onAfterDelete()
                  }
                })
                .finally(() => {
                  // $('#' + this.resourceurl).modal('hide')
                });
        }
    },
    
  },
      
  mounted() {
    this.getListSeltelur()
    
  }
}
      

</script>  
